import { Divider } from "@mui/material";

const Separator = (props) => {
  return <Divider sx={{ margin: { xs: "16px -16px", sm: "24px -24px 18px" } }} {...props} />;
};

export default Separator;
